export default {
	a_great_community_awaits_you: 'Une grande communauté vous attend',
	about_the: 'En ce qui concerne la',
	access_platform: 'Accéder à la plateforme',
	access: 'Accéder',
	active_users: '{users} utilisateurs actifs',
	an_email_has_been_sent_to: 'Un courriel a été envoyé à',
	are_you_a_continental_partner: 'Êtes-vous un partenaire Continental?',
	certificates_obtained_in_training: 'Certificats obtenus en formation',
	change_country: "Changer de pays",
	check_your_email_for_password_recovery_instructions:
		'Vérifiez votre messagerie pour les instructions de récupération de mot de passe.',
	click_on_the_button_below_to_perform_the_first_access:
		'Cliquez sur le bouton ci-dessous pour effectuer le premier accès',
	code: 'Code',
	to_the_document_informed: 'au document renseigné.',
	ddd_plus_number_ex: 'DDD plus numéro. Exemple 1199999999',
	discover_new_techniques_in_current_and_diversified_courses:
		'Découvrez de nouvelles techniques dans des cours actuels et diversifiés',
	do_apply: 'Appliquer',
	document_cpf: 'CPF',
	document: 'Document',
	email_already_in_use_click: 'Courriel déjà utilisé. Cliquez',
	enter_full_company_name: "Entrez le nom complet de l'entreprise",
	email_invalid_error: 'Adresse e-mail invalide' ,
	enter_a_new_password: 'Entrer un nouveau mot de passe.',
	enter_the_code_received_through_the_selected_recovery_method_to_create_a_new_password:
		'Entrez le code reçu par le biais de la méthode de récupération sélectionnée pour créer un nouveau mot de passe',
		enter_your_document_to_check_the_options_available_with_your_phone_number_for_password_recovery:
		'Entrez votre document pour vérifier les options disponibles avec votre numéro de téléphone pour la récupération de mot de passe.',
	enter_your_new_password: 'Entrez votre nouveau mot de passe',
	enter_your_phone_number_below_and_press_send_to_receive_a_confirmation_code:
		'Entrez votre numéro de téléphone ci-dessous et appuyez sur envoyer pour recevoir un code de confirmation.',
	error_logging_in_check_the_user_and_password_entered:
		"Erreur de connexion. Vérifiez l'utilisateur et le mot de passe saisis.",
	error_setting_new_password: 'Erreur lors de la définition du nouveau mot de passe.',
	forgot_password: 'Mot de passe oublié?',
	select_an_available_option_to_receive_the_verification_code: 'Sélectionnez une option disponible pour recevoir le code de vérification',	
	in: 'dans',
	log_in_to_receive_an_email_with_instructions_and_a_link_to_create_a_new_password:
		'Connectez-vous pour recevoir un e-mail avec des instructions et un lien pour créer un nouveau mot de passe.',
	login_to_access_your_account: 'Identifiez-vous pour accéder à votre compte',
	more_than_courses: 'Plus de {courses} cours',
	no_company_agency_found: 'Aucune entreprise/agence trouvée',
	or: 'Ou alors',
	password_changed_successfully: 'Le mot de passe a été changé avec succès.',
	password_setting_link_expired:
		"Le lien de configuration du mot de passe a expiré. Cliquez ici sur «J'ai oublié mon mot de passe» pour demander un nouveau lien.",
	phone_number: 'Numéro de téléphone',
	Please_wait_we_are_validating_your_access:
		"S'il vous plaît, attendez. Nous validons votre accès.",
	recover_password_with_sms: 'Récupérer le mot de passe avec SMS ou Whatsapp',
	recover_password_with_username: "Récupérer le mot de passe avec le nom d'utilisateur",
	recover_password: 'Récupérer mot de passe',
	recover_your_password: 'Récupérez votre mot de passe',
	request_code: 'Demande de code',
	request_new_code: 'Demander un nouveau code',
	sap_code: 'Code SAP',
	seconds: 'secondes',
	select_your_country: 'Sélectionnez votre pays',
	select: 'Sélectionner',
	send_code: 'Envoyer le code',
	set_new_password: 'Definir un nouveau mot de passe',
	sign_in: 'Entrer',
	sign_up: "S'inscrire",
	temporary_password: 'Mot de passe temporaire',
	terms_of_service: 'Termes et conditions',
	the_code_sent_is_not_valid: "Le code envoyé n'est pas valide",
	the_informed_user_could_not_be_found_please_check_the_data_provided:
		"L'utilisateur informé n'a pas pu être trouvé. Veuillez vérifier les données fournies.",
	the_number_entered_does_not_correspond_to_the_registered_number:
		'Le numéro saisi ne correspond pas au numéro enregistré',
	the_password_reset_link_is_invalid:
		'The password reset link is invalid. Please request a new one.',
	there_is_no_registered_phone_for_this_user:
		"Il n'y a pas de téléphone enregistré pour cet utilisateur",
	this_site_is_protected_by_googles_recaptcha: 'Ce site best protégé par Google reCAPTCHA',
	to_access_this_website_you_need_to_login_first_at_the_intel_retail_edge_program_and_click_on_the_intel_rewards_you_link_on_the_menu:
		"Pour accéder à ce site web, vous devez d'abord vous connecter au Intel® Retail Edge Program et cliquer sur le lien Intel Rewards You dans le menu.",
	to_recover_your_password: 'Pour récupérer votre mot de passe',
	under_maintenance: 'En maintenance',
	use_document_and_default_password_to_login:
		'Entrez votre document de connexion pour recevoir un e-mail avec des instructions et un lien pour créer un nouveau mot de passe.',
	use_only_numbers_ex: "N'utilisez que des chiffres. Ex. 123456789",
	use_your_email_or_document_to_recover_your_password:
		'Utilisez votre e-mail ou document pour récupérer votre mot de passe',
	user_doesnt_have_access: 'L’utilisateur n’a pas accès',
	user_registered_success: 'Utilisateur enregistré avec succès.',
	we_are_under_renovation_and_soon_we_will_bring_a_new_platform_full_of_news_for_you:
		'Nous sommes en cours de rénovation et nous aurons bientôt une nouvelle plateforme pleine de nouveautés pour vous!',
	we_found_the_phone_number: 'Nous avons trouvé le numéro de téléphone',
	welcome_to: 'Bienvenue à',
	to_recover_your_password_using_email_or_sms:
		'pour récupérer votre mot de passe en utilisant votre e-mail ou votre numéro de téléphone enregistré. ',
	you_can_recover_your_password_using_your_email_or_document_or_sms:
		"Cliquez sur 'Mot de passe oublié' et choisissez de le récupérer en utilisant votre e-mail (utilisez votre document ou e-mail) ou SMS (utilisez votre numéro de téléphone) et obtenez un lien pour créer un nouveau mot de passe. ",
	you_can_recover_your_password_using_your_email_or_sms:
		"Cliquez sur 'Mot de passe oublié' et choisissez de le récupérer en utilisant votre e-mail ou SMS et obtenez un lien pour créer un nouveau mot de passe. ",
	password_recovery: 'Récupération de mot de passe',
	login_azure: 'Accès Direct',
	user_not_found_contact_to: 'Utilisateur non trouvé. Contactez',
	to_request_to_access_on_the_platform: 'pour demander l\'accès à la plateforme.'
}
